// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import { atualizarLead } from "../../../services/atualizarLeadService";
import { numberPadrao } from "../../../uteis/formatPhoneNumber";

export const useAtualizarLead = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);

  const resetError = () => setError(null);

  const atualizar = async (leadId: number | undefined, leadData: any) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);
    if (leadId && leadData) {
      // Formata o celular no padrao
      leadData.celular = numberPadrao(leadData.celular);
      const leadDataNovo = {
        ...leadData,
        id: leadId,
      };
      try {
        const atualizarDados = await atualizarLead(leadDataNovo);
        if (atualizarDados) {
          setSuccess(true);
        } else {
          setError(true);
        }
        return atualizarDados;
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return { atualizar, isLoading, isSuccess, error, success, resetError };
};
